<template>
  <div>
    <!-- navigation -->
    <header class="navigation bg-primary fixed-top shadow-sm">
      <nav class="navbar navbar-expand-xl navbar-dark text-center py-3">
        <div class="container">
          <router-link class="navbar-brand" to="/"
            ><img
              loading="prelaod"
              decoding="async"
              class="img-fluid"
              width="236"
              src="@/assets/7.png"
              :alt="$t('nav.brandAlt')"
          /></router-link>

          <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            :aria-label="$t('nav.toggleAriaLabel')"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mx-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <router-link
                  class="nav-link clickable text-white"
                  :class="{
                    'nav-item': true,
                    active: $route.path === '/',
                  }"
                  to="/"
                  >{{ $t("nav.home") }}</router-link
                >
              </li>

              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle text-white"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  >{{ $t("nav.dropdowns.support.title") }}</a
                >
                <ul
                  class="dropdown-menu bg-primary"
                  aria-labelledby="navbarDropdown"
                >
                  <li>
                    <router-link
                      class="dropdown-item clickable"
                      :class="{
                        'nav-item': true,
                        active: $route.path === '/accompagnement-palliatif',
                      }"
                      to="/accompagnement-palliatif"
                      >{{
                        $t("nav.dropdowns.support.items.palliative")
                      }}</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item clickable"
                      :class="{
                        'nav-item': true,
                        active:
                          $route.path === '/situations-complexes-urgences',
                      }"
                      to="/situations-complexes-urgences"
                      >{{
                        $t("nav.dropdowns.support.items.complex")
                      }}</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item clickable"
                      :class="{
                        'nav-item': true,
                        active:
                          $route.path === '/soins-bien-etre-socio-esthetique',
                      }"
                      to="/soins-bien-etre-socio-esthetique"
                      >{{
                        $t("nav.dropdowns.support.items.wellbeing")
                      }}</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item clickable"
                      :class="{
                        'nav-item': true,
                        active:
                          $route.path === '/personnes-agees-troubles-cognitifs',
                      }"
                      to="/personnes-agees-troubles-cognitifs"
                      >{{
                        $t("nav.dropdowns.support.items.seniors")
                      }}</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item clickable"
                      :class="{
                        'nav-item': true,
                        active:
                          $route.path ===
                          '/adultes-perte-autonomie-situation-handicap',
                      }"
                      to="/adultes-perte-autonomie-situation-handicap"
                      >{{
                        $t("nav.dropdowns.support.items.adults")
                      }}</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item clickable"
                      :class="{
                        'nav-item': true,
                        active: $route.path === '/enfants-et-adolescents',
                      }"
                      to="/enfants-et-adolescents"
                      >{{ $t("nav.dropdowns.support.items.kids") }}</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item clickable"
                      :class="{
                        'nav-item': true,
                        active:
                          $route.path === '/accompagnement-en-institutions',
                      }"
                      to="/accompagnement-en-institutions"
                      >{{
                        $t("nav.dropdowns.support.items.institution")
                      }}</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item clickable"
                      :class="{
                        'nav-item': true,
                        active:
                          $route.path === '/voyages-et-residences-secondaires',
                      }"
                      to="/voyages-et-residences-secondaires"
                      >{{
                        $t("nav.dropdowns.support.items.travel")
                      }}</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item clickable"
                      :class="{
                        'nav-item': true,
                        active: $route.path === '/mise-au-lit-tardive',
                      }"
                      to="/mise-au-lit-tardive"
                      >{{
                        $t("nav.dropdowns.support.items.bedtime")
                      }}</router-link
                    >
                  </li>
                </ul>
              </li>

              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle text-white"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  >{{ $t("nav.dropdowns.about.title") }}</a
                >
                <ul
                  class="dropdown-menu bg-primary"
                  aria-labelledby="navbarDropdown"
                >
                  <li>
                    <router-link
                      class="dropdown-item clickable"
                      :class="{
                        'nav-item': true,
                        active: $route.path === '/qui-sommes-nous',
                      }"
                      to="/qui-sommes-nous"
                      >{{ $t("nav.dropdowns.about.items.who") }}</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item clickable"
                      :class="{
                        'nav-item': true,
                        active: $route.path === '/organisation-fonctionnement',
                      }"
                      to="/organisation-fonctionnement"
                      >{{
                        $t("nav.dropdowns.about.items.organization")
                      }}</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item clickable"
                      :class="{
                        'nav-item': true,
                        active: $route.path === '/approche-valeurs',
                      }"
                      to="/approche-valeurs"
                      >{{ $t("nav.dropdowns.about.items.values") }}</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item clickable"
                      :class="{
                        'nav-item': true,
                        active: $route.path === '/partenaires-reseau',
                      }"
                      to="/partenaires-reseau"
                      >{{
                        $t("nav.dropdowns.about.items.partners")
                      }}</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      class="dropdown-item clickable"
                      :class="{
                        'nav-item': true,
                        active: $route.path === '/zone-intervention',
                      }"
                      to="/zone-intervention"
                      >{{ $t("nav.dropdowns.about.items.zones") }}</router-link
                    >
                  </li>
                </ul>
              </li>

              <li class="nav-item">
                <router-link
                  class="nav-link clickable text-white"
                  :class="{
                    'nav-item': true,
                    active: $route.path === '/galerie',
                  }"
                  to="/galerie"
                  >{{ $t("nav.gallery") }}</router-link
                >
              </li>

              <li class="nav-item">
                <router-link
                  class="nav-link clickable text-white"
                  :class="{
                    'nav-item': true,
                    active: $route.path === '/contact',
                  }"
                  to="/contact"
                  >{{ $t("nav.contact") }}</router-link
                >
              </li>
            </ul>

            <!-- Language Selector -->
            <div class="nav-item dropdown">
              <img
                :src="selectedLanguageIcon"
                :alt="$t('nav.language.selectedIconAlt')"
                class="language-icon"
                id="languageDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              />

              <span
                class="selected-language font mx-1"
                id="languageDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                >{{ selectedLanguage }}
              </span>

              <ul
                class="dropdown-menu text-center bg-primary"
                aria-labelledby="languageDropdown"
              >
                <li
                  class="dropdown-item clickable"
                  v-for="lang in supportedLanguages"
                  :key="lang.code"
                  @click="changeLanguage(lang.code)"
                >
                  <img
                    :src="lang.icon"
                    :alt="$t('nav.language.iconAlt')"
                    class="language-icon"
                  />

                  <span class="selected-language font mx-2 text-white">
                    {{ lang.name }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </header>
  </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      supportedLanguages: [
        { code: "FR", name: "FR", icon: require("@/assets/img/FR.png") },
        {
          code: "NL",
          name: "NL",
          icon: require("@/assets/img/NL.png"),
        },
        { code: "DE", name: "DE", icon: require("@/assets/img/DE.png") },
        { code: "EN", name: "EN", icon: require("@/assets/img/EN.png") },
        { code: "ES", name: "ES", icon: require("@/assets/img/ES.png") },
      ],
      selectedLanguage: this.$i18n.locale,
      showDropdown: false,
    };
  },
  methods: {
    changeLanguage(langCode) {
      this.$i18n.locale = langCode;
      this.selectedLanguage = langCode;
    },
  },
  computed: {
    selectedLanguageIcon() {
      return this.supportedLanguages.find(
        (lang) => lang.code === this.selectedLanguage,
      ).icon;
    },
  },
  mounted() {
    const navbarToggler = document.body.querySelector(".navbar-toggler");
    const responsiveNavItems = [].slice.call(
      document.querySelectorAll(".clickable"),
    );

    responsiveNavItems.map(function (responsiveNavItem) {
      responsiveNavItem.addEventListener("click", () => {
        if (window.getComputedStyle(navbarToggler).display !== "none") {
          navbarToggler.click();
        }
      });
    });
  },
};
</script>

<style scoped>
.language-icon {
  width: 24px; /* Ajustez la taille de l'icône selon vos besoins */
  height: 24px;
  cursor: pointer;
}
.selected-language {
  cursor: pointer;
}

@media (max-width: 1199px) {
  #languageDropdown + .dropdown-menu {
    left: 50% !important;
    transform: translateX(-50%) !important;
    right: auto !important;
  }
}
</style>
